import React from "react"
import classes from "./about.module.css"
import photo from "../../images/about-us-image3.jpg"

const About = () => {
  return (
    <div className={classes.About} id="about">
      <div className={classes.AboutText}>
        <h2>About</h2>
        <p className={classes.separator}></p>
        <p>
          Everyone is special and deserves individual treatment designed to your
          special needs. That’s why we always choose treatments based on skin
          analysis and not on guessing what would be good for you. We use only
          the best products on the market which guarantee long lasting effects.
        </p>
        <p>Our professionalism is based on 4 elements:</p>
        <ul>
          <li>effective products and treatments: visible results</li>
          <li>only certified and tested products</li>
          <li>
            equipment which help to prepare skin to absorb active substances
          </li>
          <li>
            we please and relax your skin by using beautiful fragrance
            combinations
          </li>
        </ul>
        <p>
          We offer you wide range of products, for both professional use and
          home care. Even the best treatment may become less effective if there
          is no proper home care applied. All our products consist of only such
          components which are essential for a proper and desirable
          effectiveness. Everything for your skin comfort.
        </p>
      </div>
      <div className={classes.AboutImage}>
        <img src={photo} alt="about us image" />
      </div>
    </div>
  )
}

export default About
